export default [
    {
        id: 1,
        name: "🏴󠁧󠁢󠁥󠁮󠁧󠁿󠁧󠁢󠁥󠁮󠁧󠁿 English"
    },
    {
        id: 2,
        name: "🇫🇷 French"
    },
    {
        id: 3,
        name: "🇸🇦 Arabic"
    },
    {
        id: 4,
        name: "🇪🇸 Spanish"
    }
];
